import { Col, Row, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { initialState, reducer } from "./reducer";
import { isValidValue } from "../../../helpers/FormHelper";
import { getErrorMessage } from "../../../helpers/ErrorHelper";
import Search from "./components/Search";
import List from "./components/List";
import Add from "./components/Add";
import DiasporaReferenceService from "../../../services/Diaspora/DiasporaReferenceService";
import SimpleHeader from "../../../helpers/cards-helper/SimpleHeader";
import Edit from "./components/Edit";
import UpdateVotingStatus from "./components/UpdateVotingStatus";



const MyDiasporaReferences = () => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errorMessage, setErrorMessage] = useState(null);
    const loadingTypeReference = useRef(null);


    useEffect(() => {
        const fetchReferences = async () => {
            try {
                updateLoading(true);
                const response = await DiasporaReferenceService.getMyReferences(token, state.filters);
                const responseData = response.data;
                if (responseData) {
                    updateItems(responseData?.data, responseData?.count);
                    setErrorMessage(null);
                } else {
                    setErrorMessage('Një gabim ndodhi gjatë komunikimit me serverin!');
                    updateItems([], 0);
                }
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                setErrorMessage(errorMessage);
                updateItems([], 0);
            } finally {
                updateLoading(false);
            }
        };

        fetchReferences();
    }, [token, state.filters]);


    useEffect(() => {
        const fetchReferenceTypes = async () => {
            try {
                const response = await DiasporaReferenceService.getReferenceTypes(token);
                const responseData = response.data;
                const referenceTypeItems = isValidValue(responseData) ? responseData : [];
                dispatch({ type: 'set_reference_types', payload: referenceTypeItems });
            } catch (error) {
                dispatch({ type: 'set_reference_types', payload: [] });
            }
        };

        fetchReferenceTypes();
    }, [token]);


    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await DiasporaReferenceService.getCountries(token);
                const responseData = response.data;
                const countryItems = isValidValue(responseData) ? responseData : [];
                dispatch({ type: 'set_countries', payload: countryItems });
            } catch (error) {
                dispatch({ type: 'set_countries', payload: [] });
            }
        };

        fetchCountries();
    }, [token]);


    const updateItems = (itemsList, itemsCount) => {
        const action = {
            type: "set_items",
            payload: {
                items: itemsList,
                total: itemsCount,
            },
        };
        dispatch(action);
    };


    const updateLoading = (isLoading) => {
        const loadingType = loadingTypeReference.current;
        const action = {
            type: isValidValue(loadingType) ? `set_${loadingType}_loading` : 'set_loading',
            payload: isLoading,
        };
        dispatch(action);
    };


    const updateIndexVisibility = (index) => {
        const action = {
            type: "set_index_visibility",
            payload: index,
        };
        dispatch(action);
    };


    const onRefresh = () => {
        dispatch({ type: "refresh_list" });
    };


    const onSuccess = () => {
        updateIndexVisibility(0);
        onRefresh();
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>

                            <Row gutter={24} className="mb-3">
                                <Col span={24}>
                                    <SimpleHeader
                                        title="Lista e referencave të mia të diasporës"
                                        subtitle="Lista e referencave të mia"
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} className="mb-3">
                                <Col span={24}>
                                    <Search
                                        dispatch={dispatch}
                                        countries={state.countries}
                                        referenceTypes={state.referenceTypes}
                                        initialFilters={state.filters.searchFilters}
                                        clearLoading={state.clearLoading}
                                        searchLoading={state.searchLoading}
                                        setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} className="mb-3">
                                <Col xl={20} lg={20} md={16} sm={12} xs={12} />
                                <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                    <Button
                                        block
                                        type="primary"
                                        style={{ height: "37px" }}
                                        icon={<PlusOutlined />}
                                        onClick={() => updateIndexVisibility(1)}
                                    >
                                        Referencë e re
                                    </Button>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <List
                                        dispatch={dispatch}
                                        items={state.items}
                                        totalCount={state.totalCount}
                                        initialPagination={state.filters.pagination}
                                        loading={state.loading}
                                        errorMessage={errorMessage}
                                        onSuccess={onSuccess}
                                        setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Add
                                countries={state.countries}
                                referenceTypes={state.referenceTypes}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 2 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Edit
                                item={state.itemSelected}
                                countries={state.countries}
                                referenceTypes={state.referenceTypes}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 3 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <UpdateVotingStatus
                                item={state.itemSelected}
                                countries={state.countries}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};

export default MyDiasporaReferences;